<template>
  <div class="password-restore--wrapper uk-text-right">
    <router-link :to="{name: 'passwordRestore'}" class="password-restore" tag="span"
      >Забыли пароль?</router-link
    >
  </div>
</template>

<script>
export default {
  name: 'PasswordRestoreButton'
}
</script>

<style lang="scss" scoped>
.password-restore {
  margin-top: 10px;
  font-weight: 500;
  font-size: 1.125rem;
  color: #dd1319;
  opacity: 0.8;

  &--wrapper {
    max-width: 570px;
    width: 100%;
  }
}

.password-restore:hover {
  cursor: pointer;
  text-decoration: underline;
}
</style>
